export async function sleep(time: number) {
  await new Promise((res) =>
    setTimeout(res, process.env.NODE_ENV === 'test' ? 1 : time)
  );
}
